import React, { Component } from 'react'
import { Dispatch } from 'react-redux'
import { viewNotice, toggleNotice } from '~/services/api'
import { NoticeDTO } from '~/model'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import * as Status from '~/helper/constant/status'
import * as route from '~/helper/constant/route'
import { toastMessage } from '~/helper/function/util'
import moment from 'moment'
import $ from 'jquery'

type Props = {
    token: String,
    dispatch: Dispatch<any>,
}

type State = {
    notices: Array,
    data: Array,
    loading: Boolean,
}

export class AbstractNoticeViewComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            notices: [
                {
                    code: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    title: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    status: {
                        field: 'badge',
                        route: false,
                        sortable: true,
                    },
                    action: {
                        field: 'button',
                        route: true,
                        sortable: false,
                    },
                },
            ],
        }
        this.toggle = this.toggle.bind(this)
        this._handleChange = this._handleChange.bind(this)
    }

    componentDidMount() {
        this.loadNotice()
    }

    toggle(id) {
        toggleNotice(id, this.props.token).then((response) => {
            if (response.code == API_SUCCESS) {
                toastMessage('success', response.message)
                this.loadNotice()
            } else {
                toastMessage('error', response.message)
            }
        })
    }

    _handleChange(key, data) {
        this.setState({ [key]: data })
    }

    loadNotice() {
        this._handleChange('loading', true)
        viewNotice(this.props.token).then((response) => {
            this._handleChange('loading', false)
            let notices = []
            notices.push(this.state.notices[0])
            let dataList = []
            if (response.code == API_SUCCESS) {
                response.data.notice.map((item, index) => {
                    const data: NoticeDTO = item
                    let text = null
                    if (data.status == Status.ACTIVE) {
                        text = {
                            text: 'Active',
                            badge: 'table-green',
                            modal: 'modal_notice_' + index,
                        }
                    } else {
                        text = {
                            text: 'Inactive',
                            badge: 'table-red',
                            modal: 'modal_notice_' + index,
                        }
                    }
                    const tableData = {
                        code: {
                            text: data.code,
                        },
                        title: {
                            text: data.title,
                        },
                        status: text,
                        action: {
                            text: 'Edit',
                            route: route.superadmin.notice.edit + '/' + data.id,
                        },
                    }
                    dataList.push(data)
                    notices.push(tableData)
                })
            }
            this.setState({
                data: dataList,
                notices,
            })
        })
    }
}

export function mapStateToProps(state: Object) {
    return {
        token: state.token,
    }
}
